export default "__VITE_ASSET__BSsK2CS7__"